import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center px-6">
        <h1 className="text-6xl font-bold text-gray-900">404</h1>
        <h2 className="text-2xl font-semibold mt-4 text-gray-700">页面未找到</h2>
        <p className="mt-2 text-gray-500">
          您访问的页面不存在或已被移除
        </p>
        <div className="mt-8 space-x-4">
          <Button
            onClick={() => navigate('/')}
            variant="default"
            className="inline-flex items-center"
          >
            <Home className="w-4 h-4 mr-2" />
            返回首页
          </Button>
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="inline-flex items-center"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            返回上一页
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
